export const LaborOrderStatisticsRouting = [
  {
    path: "/report-center/download/labor-order-statistics/list",
    name: "material-labor-order-statistics-list",
    meta: { title: "劳务工单统计" },
    component: () =>
      import(
        /* webpackChunkName: "library-report" */ "@/views/report-center/labor-order-statistics/list/index.vue"
      ),
  },
];
